import { useAuth } from '../context/AuthContext';
import { rolePermissions, type Permission, type UserRole } from '../types/auth';

export function usePermissions() {
  const { user } = useAuth();
  
  // Check if user is admin (system_admin role)
  const isAdmin = user?.role === 'system_admin';
  
  // Helper function to check if user has a specific permission
  const hasPermission = (permissionToCheck: string) => {
    if (!user) return false;
    
    // Get permissions for the user's role
    const userRole = user.role as UserRole;
    const permissions = rolePermissions[userRole];
    
    // Check if the permission exists in the user's role permissions
    return permissions.includes(permissionToCheck as any);
  };
  
  return {
    // Return specific permissions based on user role
    canViewLeases: hasPermission('view_leases'),
    canEditLeases: hasPermission('edit_leases'),
    canApproveApplications: hasPermission('approve_applications'),
    canManageUsers: hasPermission('manage_users'),
    canViewReports: hasPermission('view_reports'),
    canEditCommunityData: hasPermission('edit_community_data'),
    canManageSystemSettings: hasPermission('manage_system_settings'),
    canViewAuditLogs: hasPermission('view_audit_logs'),
    canManageUserRoles: hasPermission('manage_user_roles'),
    
    // Add a general isAdmin helper
    isAdmin
  };
}
